import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-compact-left', 'IconChevronCompactLeft', [["path",{"d":"M13 20l-3 -8l3 -8","key":"svg-0"}]]);